import Pusher from "pusher-js";

const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
  cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER || "mt1",
  forceTLS: true,
});

pusher.connection.bind("state_change", (states) => {
  console.log("[Pusher] connexion:", states);
});

pusher.connection.bind("error", (error) => {
  console.error("[Pusher] erreur:", error);
});

export function subscribeToRestaurantOrders(restaurantId, callback) {
  if (!restaurantId) return () => {};

  const channelName = `restaurant-${restaurantId}`;
  console.log("[Pusher] abonnement:", channelName);

  const channel = pusher.subscribe(channelName);

  channel.bind("pusher:subscription_succeeded", () => {
    console.log("[Pusher] abonnement reussi:", channelName);
  });

  channel.bind("pusher:subscription_error", (error) => {
    console.error("[Pusher] abonnement echoue:", channelName, error);
  });

  channel.bind("new-order", (data) => {
    console.log("[Pusher] new-order recu:", channelName, data);
    callback(data);
  });

  return () => {
    channel.unbind("new-order");
    pusher.unsubscribe(channelName);
  };
}

export default pusher;
